<!-- <div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Title</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal('No')"></button>
</div> -->
<div class="modal-body">
  <div class="row">
    <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-12">
      <lib-vio-input [formsData]="paramDetails"></lib-vio-input>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
      <button type="button" class="btn btn-success btn-round btn-shadow mx-1 mt-2" (click)="addAndClose()">
        <i class="fa fa-save"></i> {{paramInfo['_id']?' Update ':' Add '}}
      </button>
      <button type="button" class="btn btn-secondary btn-round btn-shadow mx-1 mt-2" (click)="closeModal('No')">
        <i class="fa fa-times-circle"></i> Close
      </button>
    </div>
  </div>

</div>
<!-- <div class="modal-footer">

</div> -->